import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux"
import { getGenres } from "../actions"
import validate from "../utils/validate"
import axios from "axios"
import style from "./create.module.css"
import { URL_POST_VIDEOGAME } from "../utils/urls"


function CreateVideogame() {
  const dispatch = useDispatch()
  const allGenres = useSelector(state => state.genres)
  useEffect(() => {
    dispatch(getGenres())
    //console.log(allGenres);
  },[])
  const history = useHistory()
  const [videogame, setVideogame] = useState({
    name: "",
    image: "",
    description: "",
    releasedDate: "",
    rating: 0,
    platform: [],
    genres: []
  })
  const [errors, setErrors] = useState({})
  const handleInput = (e) => {
    setVideogame({
      ...videogame,
      [e.target.name]:e.target.value
    })
    setErrors(validate({
      ...videogame,
      [e.target.name]:e.target.value
    }))
  }
  const handleCheckboxGenre = (e) => {
    if(e.target.checked){
      setVideogame({
        ...videogame,
        genres: [...videogame.genres,e.target.value]
      })
      setErrors(validate({
        ...videogame,
        genres: [...videogame.genres,e.target.value]
      }))
      //console.log(e.target);
    } else{
      let genres = videogame.genres
      setVideogame({
        ...videogame,
        genres: genres.filter(genre => genre !== e.target.value)
      })
      setErrors(validate({
        ...videogame,
        genres: genres.filter(genre => genre !== e.target.value)
      }))
    }
    
  }
  const handleCheckboxPlatform = (e) => {
    if(e.target.checked){
      setVideogame({
        ...videogame,
        platform: [...videogame.platform,e.target.value]
      })
      setErrors(validate({
        ...videogame,
        platform: [...videogame.platform,e.target.value]
      }))
    } else{
      let platform = videogame.platform
      setVideogame({
        ...videogame,
        platform: platform.filter(platform => platform !== e.target.value)
      })
      setErrors(validate({
        ...videogame,
        platform: platform.filter(platform => platform !== e.target.value)
      }))
    }
  }
  const handleSubmit = async(e) => {
    e.preventDefault()
    if(Object.keys(errors).length === 0){
      try {
        const response = await axios.post(URL_POST_VIDEOGAME, videogame)
        console.log(videogame);
        alert("Videogame Created")
        history.push("/home");
        
      } catch (error) {
        console.log(error.response.data);
        alert("An error has occurred")
      }

    }else{
      alert("You must correct all errors")
    }
  }
  

  return (
    <>
    <div className={style.container}>
        <h1> Create Videogame</h1>
        
        <form onSubmit={handleSubmit} className={style.form}>
            
                <label className={style.labels} htmlFor="name">Name:</label>
                <input className={style.inputform} onChange={handleInput} type="text" name="name" autoComplete="off"></input>

                {errors.name && (<p className={style.error}>{errors.name}</p>)}
                

                <label className={style.labels} htmlFor="image">URL Image:</label>
                <input className={style.inputform} onChange={handleInput} type="text" name="image" autoComplete="off" placeholder="https://www.videogame.com/image.jpg"></input>
            
                {errors.image && (<p className={style.error}>{errors.image}</p>)}

                <label className={style.labels} htmlFor="releasedDate">Released Date:</label>
                <input className={style.inputform} onChange={handleInput} type="date" name="releasedDate" autoComplete="off"></input>
            
                {errors.releasedDate && (<p className={style.error}>{errors.releasedDate}</p>)}

                <label className={style.labels} htmlFor="rating">Rating:</label>
                <input className={style.inputform} onChange={handleInput} type="text" name="rating" autoComplete="off"></input>
            
                {errors.rating && (<p className={style.error}>{errors.rating}</p>)}

                <label className={style.labels} htmlFor="description">Description:</label>
                <textarea className={style.inputform} onChange={handleInput} type="text" name="description" autoComplete="off"></textarea>
            
              <p className={style.selector}>Select a Genre:</p>
            <div className={style.checkbox}>
              {allGenres &&
               allGenres.map((genre) => (
                
                  <label key={genre.id}> {genre.name}
                    <input type="checkbox" value={genre.name} name={genre.name} onChange={handleCheckboxGenre}>
                    </input>
                  </label>
                
              ))
              }
            </div>

            {errors.genres && (<p className={style.error}>{errors.genres}</p>)}

              <p className={style.selector}>Select a Platform:</p>
            <div className={style.checkbox}>
              
              <label> PC
                <input type="checkbox" onChange={handleCheckboxPlatform} value="PC" name="PC">
                </input>
              </label>
              <label> Playstation 5
                <input type="checkbox" onChange={handleCheckboxPlatform} value="Playstation5" name="Playstation5">
                </input>
              </label>
              <label> Playstation 4
                <input type="checkbox" onChange={handleCheckboxPlatform} value="Playstation4" name="Playstation4">
                </input>
              </label>
              <label> Xbox One
                <input type="checkbox" onChange={handleCheckboxPlatform} value="XboxOne" name="XboxOne">
                </input>
              </label>
              <label> Xbox Series S/X
                <input type="checkbox" onChange={handleCheckboxPlatform} value="XboxSeriesS" name="XboxSeriesS/X">
                </input>
              </label>
              <label> Nintendo Switch
                <input type="checkbox" onChange={handleCheckboxPlatform} value="NintendoSwitch" name="NintendoSwitch">
                </input>
              </label>
              <label> iOS
                <input type="checkbox" onChange={handleCheckboxPlatform} value="iOS" name="iOS">
                </input>
              </label>
              <label> Android
                <input type="checkbox" onChange={handleCheckboxPlatform} value="Android" name="Android">
                </input>
              </label>
              <label> Nintendo 3DS
                <input type="checkbox" onChange={handleCheckboxPlatform} value="Nintendo3DS" name="Nintendo3DS">
                </input>
              </label>
              <label> Nintendo DS
                <input type="checkbox" onChange={handleCheckboxPlatform} value="NintendoDS" name="NintendoDS">
                </input>
              </label>
              <label> Xbox 360
                <input type="checkbox" onChange={handleCheckboxPlatform} value="Xbox360" name="Xbox360">
                </input>
              </label>
              <label> Wii U
                <input type="checkbox" onChange={handleCheckboxPlatform} value="WiiU" name="WiiU">
                </input>
              </label>
              
              
            </div>

            {errors.platform && (<p className={style.error}>{errors.platform}</p>)}
            
            <button className={style.button} type="submit">Create</button>
            

        </form>
    </div>
    </>
  )
}

export default CreateVideogame